<template>
<div class="item-wrapper">
  <div :class="audio.selected?'nft':'nft-off'">
    <span :class="audio.icon +' icon-span '+ (audio.selected?'icon-nft':'icon-nft-off')" @click="changeAudioCheckbox(audio)">
    </span>
    <span class="audio-name">{{audio.name}}</span>
    <el-tooltip :content="'分组，同一组别内的多个音频不会被同时播放'" placement="top">
      <span :class="'group-span ' + ((audio.selected && this.$store.state.isPlayBgSound)?'group-text-disable':'')">
        <v-text-field density="compact" variant="solo" hide-details single-line v-model="audio.group" type="number" hide-spin-buttons :disabled="audio.selected&& this.$store.state.isPlayBgSound"></v-text-field>
        <!-- <v-otp-input length="1" model-value="-"></v-otp-input> -->
      </span>
    </el-tooltip>
    <el-tooltip :content="getStatusTip()" placement="top">
      <span :class="'playMuteIcon '+ (getStatusIcon())"></span>
    </el-tooltip>
    <el-row style="display: flex; flex-warp: warp">
      <el-col style="width: 32px;">
        <el-tooltip :content="'音量（范围内随意一个值）'" placement="top">
          <span class="sliderIcon cuida--volume-2-outline"></span>
        </el-tooltip>
      </el-col>
      <el-col style="text-align: left;">
        <!-- <v-range-slider class="volume-slider" v-model="audio.volumeRange" :thumb-size="24" thumb-label :step="0.01" :min="0" :max="1" @end="updateVolume(audio)"></v-range-slider> -->
        <el-slider class="volume-slider" v-model="audio.volumeRange" range :step="0.01" :min="0" :max="1" @change="updateVolume(audio)" :show-tooltip="!isMobile">
        </el-slider>
        <div class="volume-label-wrapper" :style="{left: (audio.volume*100) +'%'}">
          <div class="volume-label"></div>
        </div>
      </el-col>
    </el-row>
    <el-row style="display: flex; flex-warp: warp">
      <el-col style="width: 32px;">
        <el-tooltip :content="'触发周期（范围内随意一个值，秒）'" placement="top">
          <span class="sliderIcon ion--hourglass-outline"></span>
        </el-tooltip>
      </el-col>
      <el-col style="text-align: left;">
        <el-slider class="time-period-slider" v-model="audio.timePeriodRange" range :step="10" :min="10" :max="300" @change="updateTimePeriod(audio)" :show-tooltip="!isMobile">
        </el-slider>
      </el-col>
    </el-row>
    <el-row style="display: flex; flex-warp: warp">
      <el-col style="width: 32px;">
        <el-tooltip :content="'概率（触发播放的概率）'" placement="top">
          <span class="sliderIcon ion--dice-outline"></span>
        </el-tooltip>
      </el-col>
      <el-col style="text-align: left;">
        <el-slider class="frequency-slider" v-model="audio.frequency" :step="0.01" :min="0" :max="1" @change="updateFrequency(audio)" :show-tooltip="!isMobile"></el-slider>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
export default {
  props: ["audio"],
  // chooseEmoji: {
  //   type: Boolean
  // }
  data: function () {
    return {
      timer: '',
      tweenTimer: '',
      preVolume: 0,
      from: 0,
      to: 0,
      count: 0,
      sumCount: 0
    };
  },
  methods: {
    changeAudioCheckbox(audio) {
      audio.selected = !audio.selected;
      this.$emit("changeAudioCheckbox", audio);
      if (audio.selected) {
        this.runningTimer();
      } else {
        this.stopTimer();
      }
    },
    updateTimePeriod(audio) {

    },
    updateFrequency(audio) {

    },

    updateVolume(audio) {
      var oldVolume = audio.volume;
      if (audio.volume < audio.volumeRange[0]) {
        audio.volume = audio.volumeRange[0];
      }
      if (audio.volume > audio.volumeRange[1]) {
        audio.volume = audio.volumeRange[1];
      }
      // console.log(audio.volumeRange)
      if (Math.abs(audio.volume - oldVolume) > 0.01) {
        this.from = oldVolume
        this.to = audio.volume
        this.count = 0
        this.sumCount = 4
        this.tweenTimer = setTimeout(this.tweenVolume, 1000);
      }
    },
    tweenVolume() {
      // console.log("tweenVolume:" + this.from)
      // console.log("tweenVolume:" + this.to)
      // console.log("tweenVolume:" + this.count)
      if (this.count >= this.sumCount) {
        return;
      }
      this.count++;
      this.audio.volume = this.from + (this.to - this.from) * this.count / this.sumCount;
      // console.log("tweenVolume:" + this.audio.volume)
      this.$emit("updateVolume", this.audio);
      this.tweenTimer = setTimeout(this.tweenVolume, 1000);
    },
    getSumCountByDeltaTime(deltaTime) {
      if (deltaTime < 20000) {
        return 8
      } else if (deltaTime < 100000) {
        return 20
      } else {
        return 40
      }
    },
    runningTimer() {
      var deltaTime = (Math.floor(Math.random() * (this.audio.timePeriodRange[1] - this.audio.timePeriodRange[0])) + this.audio.timePeriodRange[0]) * 1000;
      // console.log("runningTimer:" + deltaTime)
      if (this.audio.isPlaying) {
        if (Math.random() < this.audio.frequency) {
          // 落在播放概率范围内，执行播放
          this.$emit("tryOccupyGroup", this.audio);
          if (!this.audio.isGroupOccupied) {
            //无法争夺到分组占用权，跳过
          } else {
            this.audio.isMute = false;
            if (Math.abs(this.audio.volumeRange[1] - this.audio.volumeRange[0]) > 0.01) {
              var randomVolume = (Math.floor(Math.random() * 100 * (this.audio.volumeRange[1] - this.audio.volumeRange[0])) + this.audio.volumeRange[0] * 100) / 100;
              this.from = this.audio.volume
              this.to = randomVolume
              this.count = 0
              this.sumCount = this.getSumCountByDeltaTime(deltaTime)
              this.tweenVolume();
            } else {
              this.to = this.audio.volumeRange[0];
              this.from = this.audio.volume
              if (Math.abs(this.from - this.to) > 0.01) {
                this.count = 0
                this.sumCount = this.getSumCountByDeltaTime(deltaTime)
                this.tweenVolume();
              } else {
                this.$emit("updateVolume", this.audio);
              }
            }
          }
        } else {
          // 没有落在播放概率内，如果占用了分组，则需要释放分组
          if (this.audio.isGroupOccupied) {
            this.$emit("tryReleaseOccupyGroup", this.audio);
          }
          this.audio.isMute = true;
          if (this.audio.volume > 0.01) {
            this.from = this.audio.volume
            this.to = 0
            this.count = 0
            this.sumCount = this.getSumCountByDeltaTime(deltaTime)
            this.tweenVolume();
          }
        }
      }
      this.timer = setTimeout(this.runningTimer, deltaTime);
    },

    stopTimer() {
      clearTimeout(this.timer);
      clearTimeout(this.tweenTimer);
    },
    getStatusIcon() {
      // 明确获取downloadState，以便被响应式识别到
      var a = this.audio.downloadState;
      // console.log("getStatusIcon "+a)

      if (!this.$store.state.isPlayBgSound || !this.audio.selected) {
        return 'quill--mute'
      }
      switch (this.audio.downloadState) {
        case "DOWNLOADING":
          return "eos-icons--loading"
        case "FAILED":
          return "ix--error"
      }
      if (this.audio.isMute) {
        if (Number(this.audio.group) != 0 && !this.audio.isGroupOccupied) {
          return "mingcute--warning-line"
        }
        return 'mynaui--stop'
      } else {
        if (this.audio.isPlaying) {
          if (Number(this.audio.group) != 0 && !this.audio.isGroupOccupied) {
            return "mingcute--warning-line"
          }
          return 'quill--play'
        } else {
          return 'quill--mute'
        }
      }
    },
    getStatusTip() {
      var str = this.getStatusIcon();
      switch (str) {
        case 'quill--mute':
          return '已关闭';
        case 'mingcute--warning-line':
          return "分组被占用，静音";
        case 'mynaui--stop':
          return '概率未命中，静音';
        case 'quill--play':
          return '播放中';
        case 'eos-icons--loading':
          return '下载音频中...';
        case 'ix--error':
          return '下载音频失败';
      }
    }
  },
  mounted() {
    if (this.audio.selected) {
      this.runningTimer();
    }
  },
  computed: {
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.tweenTimer);
  }
};
</script>

<style lang="less" scoped>
.volume-label-wrapper {
  position: relative;
  display: inline;
  top: -26px;
}

.volume-label {
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border: 6px solid transparent;
  border-top-color: #409EFF;
  transition: .2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  left: -6px;
  position: absolute;
}

.item-wrapper {
  width: 100px;
}

.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

@media (min-width: 760px) {
  .nft-off {
    text-align: center;
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    transition: .5s all;
    user-select: none;
    padding: 8px;
    border: 1px solid #ffffff22;
    background-color: #282c34;
    background: linear-gradient(0deg, rgba(40, 44, 52, 1) 0%, rgba(17, 0, 32, .5) 100%);
    box-shadow: 0 2px 5px 1px #00000088;
    border-radius: .7rem;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    overflow: hidden;
    transition: .5s all;

    ::before {
      position: fixed;
      content: "";
      box-shadow: 0 0 100px 40px #ffffff08;
      top: 100%;
      left: -100%;
      transform: rotate(-45deg);
      height: 20rem;
      transition: .3s all;
    }

    &:active {
      border: 1px solid #ffffff44;
      box-shadow: 0 2px 10px 2px #000000aa;
      /* transform: scale(1.015); */
      filter: brightness(1.3);

      ::before {
        filter: brightness(.5);
        top: -120%;
        left: 200%;
      }
    }
  }

  .icon-nft-off {
    transition: .3s all;

    &:active {
      transform: translateY(4px);
    }
  }

  .nft {
    text-align: center;
    user-select: none;
    padding: 8px;
    border: 1px solid #ffffff22;
    background-color: #282c34;
    background: linear-gradient(0deg, rgba(40, 44, 52, 1) 0%, rgba(17, 0, 32, .5) 100%);
    box-shadow: 0 2px 5px 1px #00000088;
    border-radius: .7rem;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    overflow: hidden;
    transition: .5s all;

    ::before {
      position: fixed;
      content: "";
      box-shadow: 0 0 100px 40px #ffffff08;
      top: -120%;
      left: 200%;
      transform: rotate(-45deg);
      height: 20rem;
      transition: .3s all;
    }
  }

  .icon-nft {
    transition: .3s all;

    &:active {
      transform: translateX(8px);
    }
  }
}

@media (max-width: 759px) {
  .nft-off {
    text-align: center;
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    user-select: none;
    padding: 8px;
    border: 1px solid #ffffff22;
    background-color: #282c34;
    background: linear-gradient(0deg, rgba(40, 44, 52, 1) 0%, rgba(17, 0, 32, .5) 100%);
    box-shadow: 0 2px 5px 1px #00000088;
    border-radius: .7rem;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    overflow: hidden;

  }

  .nft {
    text-align: center;
    user-select: none;
    padding: 8px;
    border: 1px solid #ffffff22;
    background-color: #282c34;
    background: linear-gradient(0deg, rgba(40, 44, 52, 1) 0%, rgba(17, 0, 32, .5) 100%);
    box-shadow: 0 2px 5px 1px #00000088;
    border-radius: .7rem;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    overflow: hidden;

  }

}

.icon-span {
  cursor: url("~@/assets/images/pointer.png"), default;
  margin-bottom: 0px;
  margin-top: 18px;
}

.volume-slider {}

.time-period-slider {
  top: -10px;
}

.frequency-slider {
  top: -10px;
}

:deep(.el-slider__button) {
  width: 12px;
  height: 12px;
}

:deep(.el-slider__runway) {
  margin: 8px 0px;
}

.playMuteIcon {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: .7rem;
  border: 2px solid #82828288;
  position: fixed;
  right: 8px;
  top: 8px;
  border-radius: 50%;
  background-color: #82828288;
  padding: 6px;
}

.sliderIcon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: .7rem;
  border: 2px solid #82828288;
  left: -2px;
  border-radius: 25%;
  background-color: #82828288;
  padding: 6px;
  position: relative;
}

.audio-name {
  font-size: 18px;
  margin: 0px 0 12px 0;
  display: block;
  font-weight: 500;
  color: #ccc;
}

.group-span {
  display: inline-block;
  width: 18px;
  height: 22px;
  position: fixed;
  left: 10px;
  top: 10px;
  font-size: 12px;
  border-radius: 25%;

  :deep(.v-input__slot) {
    min-height: 22px
  }

  :deep(.v-text-field) {
    padding-top: 0px;
    margin-top: 0px;
  }

  :deep(.v-text-field) input {
    padding: 0 !important;
    border-radius: 25%;
    background-color: #e3e3e388;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
  }
}

.group-text-disable {
  background:
    linear-gradient(to top left,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) calc(50% - 2px),
      rgba(0, 0, 0, 0.25) calc(50% - 1px),
      rgba(0, 0, 0, 0.25) calc(50% + 1px),
      rgba(0, 0, 0, 0) calc(50% + 2px),
      rgba(0, 0, 0, 0) 100%),
}
</style>
